import { CircularProgress, Container } from "@mui/material";
import ItemList from "../../components/ItemList";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { getBackend } from "../../api/backend";
import { useState, useEffect } from "react";


const Users = () => {
  const [groups, setGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fieldsConfig = [
    { key: "uuid", label: "Placeholder", type: "text", displayForm: false, displayList: false },
    { key: "username", label: "Usuario", type: "text", required: true, displayForm: true, displayList: true },
    { key: "email", label: "Email", type: "text", displayForm: true, displayList: true },
    { key: "first_name", label: "Nombre", type: "text", required: true, displayForm: true, displayList: true },
    { key: "last_name", label: "Apellido", type: "text", required: true, displayForm: true, displayList: true },
    { key: "groups", label: "Grupos", type: "select-multiple", options: groups, required: true, displayForm: true, displayList: true },
    { key: "is_active", label: "Activo", type: "bool", displayForm: true, displayList: true },
    { key: "password", label: "Contraseña", type: "text" , displayForm: true, displayList: false, required: true },
  ];

  const fetchFormInfo = async () => {
    const tempGroups = await getBackend("groups");
    setGroups(
      Object.fromEntries(tempGroups.map((item) => [item.uuid, item.name]))
    );
    setIsLoading(false)
  };

  useEffect(() => {
    fetchFormInfo();
  }, []);

  return  isLoading ? <CircularProgress /> : (
    <Container maxWidth={false} disableGutters>
      <Box sx={{ display: "flex", justifyContent: "flex-start", marginBottom: "3%" }}>
        <Typography variant="h5" noWrap component="div"> 
          Usuarios
        </Typography>
      </Box>
      <ItemList fields={fieldsConfig} tableName="users" hasCheckbox={true} objectName={"user"} tabledescription={"Usuarios"}/>
    </Container>
  );
};

export default Users;